import { Badge, IconButton } from "@mui/material"
import i18n from "i18n-js"
import { useContext, useMemo } from "react"
import { AuthContext } from "../../../../../context/auth"
import { canAccess } from "../../../../../router/permissions"
import { actionKeys, Icons, pagesKeys } from "../../../../../utils"

export const useColumns = ({ onOpenGallery } = {}) => {
  const { state } = useContext(AuthContext)
  const observationId = pagesKeys.observation
  const canCreate = canAccess(actionKeys.create, observationId, state)
  const canEdit = canAccess(actionKeys.edit, observationId, state)
  const cnaDelete = canAccess(actionKeys.delete, observationId, state)

  const columns = useMemo(() => {
    const list = [
      {
        field: 'createdDate',
        headerName: i18n.t('observation.createdDate'),
        flex: 1,
        sortable: true,
      },
      {
        field: 'observation_type',
        headerName: i18n.t('observation.observationType'),
        flex: 1,
        sortable: true,
      },
      {
        field: 'creator',
        headerName: i18n.t('observation.creator'),
        flex: 1,
        sortable: true,
      },
      {
        field: 'patient',
        headerName: i18n.t('observation.patient'),
        flex: 1,
        sortable: true,
      },
      {
        field: 'comment',
        headerName: i18n.t('observation.comment'),
        flex: 2,
        cellClassName: 'commentCell',
        sortable: true,
        renderCell: (params) => (
          <span
            style={{
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              overflow: 'visible',
            }}
          >
            {params.value}
          </span>
        ),
      },
      {
        field: 'photos',
        headerName: i18n.t('observation.photos.count'),
        width: 90,
        sortable: false,
        align: 'center',
        headerAlign: 'center',
        renderCell: ({ row }) => {
          const count = row.photos?.length || 0
          if (!count) return null
          return (
            <IconButton size="small" onClick={() => onOpenGallery(row)}>
              <Badge badgeContent={count} color="secondary">
                {Icons('camera')}
              </Badge>
            </IconButton>
          )
        },
      },
      // {
      //   field: 'actions',
      //   headerName: i18n.t('general.actions'),
      //   headerAlign: 'center',
      //   width: 170,
      //   sortable: false,
      //   valueFormatter: ({ value }) => value ?? '',
      //   hide:
      //     canEdit ||
      //       cnaDelete
      //       ? false
      //       : true,
      //   renderCell: ({ row }) => (
      //     <Grid container justifyContent="center">
      //       {/* <IconButton
      //         onClick={() => {
      //           onView(row)
      //         }
      //         }
      //         color="secondary"
      //       >
      //         {Icons('show')}
      //       </IconButton> */}

      //       {canEdit && (
      //         <IconButton
      //           onClick={() => {
      //             onEdit(row)
      //           }
      //           }
      //           color="secondary"
      //         >
      //           {Icons('edit')}
      //         </IconButton>
      //       )}
      //       {cnaDelete && (
      //         <IconButton
      //           onClick={(e) => {
      //             onDelete(row.id, e)
      //           }}
      //         >
      //           {Icons('delete')}
      //         </IconButton>
      //       )}
      //     </Grid>
      //   ),
      // }
    ]
    if (!canEdit && !cnaDelete) {
      return list.filter(item => item.field !== "actions")
    }
    return list
  }, [observationId, canCreate, canEdit, cnaDelete, onOpenGallery])

  return {
    state,
    observationId,
    canCreate,
    column: columns
  }
}